// "原文 · English" on one line — the packing-station issue reason with its translation (when available).
export const holdReasonText = (o) => {
  const base = String(o?.hold_reason || "").trim();
  const tr = String(o?.hold_reason_translation || "").trim();
  return tr && tr !== base ? `${base} · ${tr}` : base;
};
